module.exports = __webpack_public_path__ + "media/images/icons/logo-bi-white-8139e45ab52e740f8ab49a6a2da5e2c1.svg";